import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

/** Logo enter — Uber-style scale + fade + slight rise */
const logoEnter = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.86) translateY(16px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

/** Subtle hold pulse (very gentle, like Uber's polished feel) */
const logoSettle = keyframes`
  0%, 100% {
    transform: scale(1) translateY(0);
  }
  50% {
    transform: scale(1.02) translateY(0);
  }
`;

/** Background fades in on open */
const backdropEnter = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

/** Whole splash fades out before Home */
const splashExit = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
`;

const ENTER_MS = 720;
const SETTLE_MS = 880;
const EXIT_MS = 400;
export const LOGO_SPLASH_DURATION_MS = ENTER_MS + SETTLE_MS + EXIT_MS;

const LogoSplashScreen = ({ onComplete, durationMs = LOGO_SPLASH_DURATION_MS }) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, durationMs);
    return () => clearTimeout(timer);
  }, [onComplete, durationMs]);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#0A2A66',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        animation: [
          `${backdropEnter} 380ms ease-out forwards`,
          `${splashExit} ${EXIT_MS}ms cubic-bezier(0.4, 0, 1, 1) ${ENTER_MS + SETTLE_MS}ms forwards`,
        ].join(', '),
      }}
    >
      <Box
        component="img"
        src="/logo.png"
        alt="NIStylez"
        sx={{
          maxWidth: { xs: '68%', sm: '48%' },
          maxHeight: { xs: 96, sm: 132 },
          objectFit: 'contain',
          opacity: 0,
          willChange: 'transform, opacity',
          animation: [
            `${logoEnter} ${ENTER_MS}ms cubic-bezier(0.22, 1, 0.36, 1) forwards`,
            `${logoSettle} ${SETTLE_MS}ms ease-in-out ${ENTER_MS}ms forwards`,
          ].join(', '),
        }}
      />
    </Box>
  );
};

export default LogoSplashScreen;
